import { ITableActionButtonDetail } from '@/@types/ui/Table'
import React from 'react'
import { useTranslation } from 'react-i18next';
import TableButton from './TableButton';

import FileDownloadIcon from "@mui/icons-material/FileDownloadOutlined";

const TableButtonDownloadExcel = (props: ITableActionButtonDetail) => {
  const { t } = useTranslation();
    
  return (
    <TableButton allow="one" startIcon={<FileDownloadIcon />} selection={[]} {...props}>
      {t('buttons.excel_obrazac')}
    </TableButton>
  )
}

export default TableButtonDownloadExcel